import { render, staticRenderFns } from "./RailNavigation.vue?vue&type=template&id=5203a34f&scoped=true"
import script from "./RailNavigation.vue?vue&type=script&lang=js"
export * from "./RailNavigation.vue?vue&type=script&lang=js"
import style0 from "./RailNavigation.vue?vue&type=style&index=0&id=5203a34f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203a34f",
  null
  
)

export default component.exports